/**
 * Company Content Configuration
 * 
 * Centralized configuration for all company information, contact details, and social media links.
 * This file serves as the single source of truth for company-related content across the application.
 * 
 * @last-updated 2026-01-01
 */

// Company Information
export const COMPANY_INFO = {
  name: 'pixshiv',
  legalName: 'pixshiv',
  tagline: 'Professional Web Development & Digital Marketing company',
  description: 'Professional digital marketing and web design company specializing in web development, mobile app development, SEO services, and ROI-driven digital marketing strategies.',
  foundedYear: 2020,
  logo: '/assets/pixshiv_logo.png',
  logoUrl: 'https://pixshiv.com/assets/pixshiv_logo.png'
};

// Contact Information
export const CONTACT_INFO = {
  phone: '+919410569992 ',
  phoneDisplay: '+91 94105 69992',
  landline: '+911354152057',
  landlineDisplay: '+91 1354 152057',
  email: 'info@pixshiv.com',
  supportEmail: 'info@pixshiv.com',
  salesEmail: 'info@pixshiv.com',
  
  // Address
  address: {
    street: 'Lane no 4, sector 4',
    city: 'Rishikesh',
    state: 'Uttarakhand',
    stateCode: 'UK',
    zip: '249201',
    country: 'India',
    countryCode: 'IN'
  },
  
  // Business Hours
  businessHours: {
    display: 'Mon-Fri 09:00 AM - 06:00 PM',
    timezone: 'IST',
    weekdays: {
      open: '09:00',
      close: '18:00'
    },
    saturday: 'Closed',
    sunday: 'Closed'
  }
};

// Social Media Links
export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/pixshiv',
  twitter: 'https://twitter.com/pixshiv',
  linkedin: 'https://www.linkedin.com/company/pixshiv',
  instagram: 'https://www.instagram.com/pxshiv',
  youtube: 'https://www.youtube.com/@pixshiv',
  github: 'https://github.com/pixshiv',
  whatsapp: 'https://wa.me/919410569992?text=Hi%2C%20I%27m%20interested%20in%20your%20services',
  whatsappNumber: '+919410569992'
};

// Geo Location
export const GEO_LOCATION = {
  latitude: 30.1158,
  longitude: 78.2853
};

// Rating Information
export const COMPANY_RATING = {
  value: '4.9',
  count: '150'
};
